import { APIConfiguration } from '@savgroup-front-common/configuration';
import { CIVILITY, SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AddressInfoDto,
  BackResponse,
  CUSTOMER_TYPE,
  ReverseMoney,
} from '@savgroup-front-common/types';

import { PreparedProduct } from '../../../view/components/CreateFile/common/components/Steps/CustomerInformation/steps/EditCustomerInformation/EditCustomerInformation.adapters';

const ENDPOINT = `${APIConfiguration.owner}creation/orders`;

type OrderId = string;

type Order =
  | {
      orderReference: string;
      civility: CIVILITY;
      customerLastName: string;
      customerFirstName: string;
      address: AddressInfoDto;
      phoneNumber: string;
      customerMail: string;
      purchaseDateUtc: string;
      products: {
        modelId: string;
        price: ReverseMoney;
        orderLineReference: string;
        supplierId?: string;
        orderProductAdditionalInfo?: {
          uniqueKey: string;
          value: string;
        }[];
        shippingPrice?: ReverseMoney;
        soldWarrantyId?: string;
        soldWarrantyPrice?: ReverseMoney;
      }[];
      shippingPrice: ReverseMoney;
      isProductShippingPrice?: boolean;
      salesChannel: string;
      sellerId: string;
      storePurchasedAt?: string;
      orderRegistrationType?: string;
      saleReceiptNumber?: string;
      orderSource?: string;
    }
  | {
      orderReference?: string;
      customerType: CUSTOMER_TYPE.STOCK;
      purchaseDateUtc: string;
      products: PreparedProduct[];
      shippingPrice: ReverseMoney;
      salesChannel: string;
      sellerId: string;
      storePurchasedAt?: string;
    };

async function createOrder({ order }: { order: Order }): Promise<OrderId> {
  const response = await apiCall<BackResponse<OrderId>>(ENDPOINT, {
    method: SUPPORTED_METHODS.POST,
    json: order,
  });

  if (response.failure) {
    throw response.errors;
  }

  return response.value;
}

export default createOrder;
